import { createReducer, on } from '@ngrx/store';
import { initialUiState, UiState } from './ui.state';
import * as UiActions from './ui.actions';

export const uiReducer = createReducer(
  initialUiState,
  on(UiActions.toggleSidebar, (state) => ({ ...state, sideBarIsOpen: !state.sideBarIsOpen })),
  on(UiActions.setSidebar, (state, { isOpen }) => ({ ...state, sideBarIsOpen: isOpen })),

  on(UiActions.toggleFullscreen, (state) => ({ ...state, isFullscreen: !state.isFullscreen })),
  on(UiActions.setFullscreen, (state, { isFullscreen }) => ({ ...state, isFullscreen }))
);
